import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { OnlineStatement } from "../../../api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import timeDateOptions from "../../../components/timeList/timeDateOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
export default {
  name: "onlineStay",
  components: {
    serverList: serverList,
    timeDateOptions: timeDateOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    return {
      searchInfo: {
        server_id: []
      },
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      tableData: [],
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "range_str",
        title: "在线区间"
      }, {
        field: "num",
        title: "人数",
        sortable: true
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.timedata[0];
              _this.searchInfo.edate = _this.timedata[1];
              _context.next = 4;
              return OnlineStatement(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "在线时长统计",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）统计不同在线时间活跃玩家的数量</div>" + "<div>（2）时间区间包括：1分钟以内，1-3，3-5，5-10，10-20，20-30，30-60分钟。1-2，2-3，3小时以上</div>",
        duration: 0
      });
    }
  }
};